import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import BreedSwitcher from './../../components/BreedSwitcher/BreedSwitcher';
import * as actionTypes from './../../store/actions/breedAction';
import fetchBreedAction from './../../store/actions/fetch/fetchBreedAction';
import Loader from './../../components/Loader/Loader'
import * as productsActionTypes from './../../store/actions/productsAction';

/**
 * Breed container
 */
class Breed extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, readyAnimalType, selectedAnimalType, selected,
      onSelect, defaultValues, ready, selectedType, onResetSelectedProducts} = this.props;
    // If there is a need for default data
    if(!error && !pending && readyAnimalType && (!ready ||
      selectedType !== selectedAnimalType)) {
      defaultValues(selectedAnimalType);
    }

    // If Animal type or Breed data is pending
    if(pending || !readyAnimalType || !ready) return (
      <Loader/>
    );


    // Select data for animal type
    const dataForType = data.data[selectedAnimalType];

    return (
      <div className='nppe2-fc-breed-switcher__wrapper'>
        {error && <span className='nppe2-fc-breed-switcher__error'>{error}</span>}

        {!error &&
        <BreedSwitcher
          data={dataForType}
          label={data.label}
          noOptionsMsg={data.noOptionsMsg}
          selected={selected}
          onSelect={onSelect}
          onResetSelectedProducts={onResetSelectedProducts}
        />
        }

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.breedReducer.selected,
    selectedData: state.breedReducer.selectedData,
    selectedType: state.breedReducer.selectedType,
    error: state.breedReducer.error,
    data: state.breedReducer.data,
    pending: state.breedReducer.pending,
    readyAnimalType: state.animalTypeReducer.ready,
    selectedAnimalType: state.animalTypeReducer.animalType,
    ready: state.breedReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchBreedAction
      },
      dispatch,
    ),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    defaultValues: (selectedAnimalType) => dispatch({
      type: actionTypes.DEFAULT,
      selectedAnimalType: selectedAnimalType,
    }),
    onResetSelectedProducts: () => dispatch({
      type: productsActionTypes.RESET_PRODUCTS,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Breed);
